import { CoreIcon } from '../core-icon';
import discountSVG from '../../assets/icons/discount.svg';
import type { IconProps } from '../core-icon';

export const DiscountIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={discountSVG} {...props} />;
};
